import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: async (email, password) => {
        try {
          const response = await api.post('/auth/login', { email, password });
          const { user, token } = response.data;

          set({
            user,
            token,
            isAuthenticated: true,
          });

          localStorage.setItem('token', token);
          return { success: true, user };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data?.error || 'Login failed',
          };
        }
      },

      register: async (userData) => {
        try {
          const response = await api.post('/auth/register', userData);
          const { user, token } = response.data;

          set({
            user,
            token,
            isAuthenticated: true,
          });

          localStorage.setItem('token', token);
          return { success: true };
        } catch (error) {
          console.error('Registration error:', error.response?.data);

          // Extract specific validation errors if available
          let errorMessage = 'Registration failed';
          if (error.response?.data?.details) {
            const details = error.response.data.details;
            if (Array.isArray(details) && details.length > 0) {
              errorMessage = details.map(d => d.msg || d.message).join(', ');
            } else if (typeof details === 'string') {
              errorMessage = details;
            }
          } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
          }

          return {
            success: false,
            error: errorMessage,
          };
        }
      },

      logout: () => {
        localStorage.removeItem('token');
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: { ...state.user, ...userData },
        }));
      },

      forgotPassword: async (email) => {
        try {
          const response = await api.post('/auth/forgot-password', { email });
          return { success: true, message: response.data.message, token: response.data.resetToken };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data?.error || 'Failed to request password reset',
          };
        }
      },

      resetPassword: async (token, newPassword) => {
        try {
          const response = await api.post('/auth/reset-password', { token, newPassword });
          return { success: true, message: response.data.message };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data?.error || 'Failed to reset password',
          };
        }
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
